const API_PATH = '/api/v2';

export { API_PATH };
